export const routes = {
    articles: 'articles',
    plugin: 'plugin',
    server: 'server',
    saveInjectSettings: 'save-inject-settings',
    getInjectSettings: 'get-inject-settings',
    contactFormSubmit: 'contact-form/submit',
    getAllForms: 'forms',
    getFormsList: 'forms/list',
    createForm: 'forms',
    getForm: 'forms/:id',
    updateForm: 'forms/:id',
    deleteForm: 'forms/:id',
    duplicateForm: 'forms/:id/duplicate',
    toggleFormVisibility: 'forms/:id/toggle-visibility'
} as const

